import {Button, Col, Row, Typography} from "@bezlimit/bezlimit-ui";
import {observer} from "mobx-react";
import _ from "lodash";
import gos from "../../../../images/gos.svg";
import gos2 from "../../../../images/gos2.png";
import "./style.scss";
import img from "../../../../images/9-1.png";
import {useContext} from "react";
import {ModalContext} from "../../../../core/Contexts";
// import ModalGos from "../modalGos";
// import {IFetchPhoneObject} from "../../../../core/models/User";
import Status from "./status";
import StatusText from "./statusText";
import moment from "moment";
import {IReservations} from "../../../../core/models/Reservations";
import Axios, {IAxiosConfig} from "../../../../core/Axios";
import {useNavigate} from "react-router-dom";

export default observer(function ModalPassportView({reservations}: IProps) {
    const contextModal = useContext(ModalContext);
    const navigate = useNavigate();

    const onClick = async () => {
        await Axios({
            url: "/reservations/passport",
            method: "PUT",
            data: {
                lastname: _.get(reservations, "phone.abonentPassport.firstname"),
                firstname: _.get(reservations, "phone.abonentPassport.firstname"),
                patroname: _.get(reservations, "phone.abonentPassport.patroname"),
                birthday: _.get(reservations, "phone.abonentPassport.birthday"),
                gender: _.get(reservations, "phone.abonentPassport.gender"),
                birth_place_name: _.get(reservations, "phone.abonentPassport.birth_place_name"),
                document_series: _.get(reservations, "phone.abonentPassport.document_series"),
                passport_nomer: _.get(reservations, "phone.abonentPassport.passport_nomer"),
                division_code: _.get(reservations, "phone.abonentPassport.division_code"),
                passport_kogda_vidan: _.get(
                    reservations,
                    "phone.abonentPassport.passport_kogda_vidan"
                ),
                passport_vidan: _.get(reservations, "phone.abonentPassport.passport_vidan"),
                place_name: _.get(reservations, "phone.abonentPassport.place_name"),
                street_name: _.get(reservations, "phone.abonentPassport.street_name"),
                house: _.get(reservations, "phone.abonentPassport.house"),
                building_name: !_.isNil(_.get(reservations, "phone.abonentPassport.building_name"))
                    ? _.get(reservations, "phone.abonentPassport.building_name")
                    : "-",
                apartment_name: _.get(reservations, "phone.abonentPassport.apartment_name"),
                phone: _.get(reservations, "phone_number"),
                status: "declined"
            }
        } as IAxiosConfig);

        navigate(
            `/signature/step1?id=${_.get(reservations, "tariff.id")}&phone=${_.get(
                reservations,
                "phone_number"
            )}`
        );

        contextModal?.setMaskStyle(undefined);
        contextModal?.setCssClass("");
        contextModal?.setVisible(false);
    };

    return (
        <Typography as="div" className="bl-modal-passport-view">
            <Typography as="div" fontFamily="alumna" className="view-title" size={48} color="#fff">
                Паспортные данные
            </Typography>
            <Typography className="view-container" as="div">
                <Row gutter={[24, 24]} className="top">
                    <Col xs={24} md={12}>
                        <Typography
                            className="label"
                            size={12}
                            as="div"
                            color="rgba(255, 255, 255, 0.50)"
                        >
                            Фамилия Имя Отчество
                        </Typography>
                        <Typography className="value" size={14} as="div" color="#fff">
                            {_.get(reservations, "phone.abonentPassport.lastname") &&
                            _.get(reservations, "phone.abonentPassport.firstname") ? (
                                <>
                                    {_.get(reservations, "phone.abonentPassport.lastname")}{" "}
                                    {_.get(reservations, "phone.abonentPassport.firstname")}{" "}
                                    {_.get(reservations, "phone.abonentPassport.patroname") ?? ""}
                                </>
                            ) : (
                                "-"
                            )}
                        </Typography>
                    </Col>
                    <Col xs={12} md={6}>
                        <Typography
                            className="label"
                            size={12}
                            as="div"
                            color="rgba(255, 255, 255, 0.50)"
                        >
                            Дата рождения
                        </Typography>
                        <Typography className="value" size={14} as="div" color="#fff">
                            {_.get(reservations, "phone.abonentPassport.birthday")
                                ? moment(
                                      _.get(reservations, "phone.abonentPassport.birthday")
                                  ).format("DD.MM.YYYY")
                                : "-"}
                        </Typography>
                    </Col>
                    <Col xs={12} md={6}>
                        <Typography className="value mt-7" size={14} as="div" color="#fff">
                            {_.get(reservations, "phone.abonentPassport.gender")
                                ? `${
                                      _.isEqual(
                                          _.get(reservations, "phone.abonentPassport.gender"),
                                          "m"
                                      )
                                          ? "Муж."
                                          : "Жен."
                                  }`
                                : "-"}
                        </Typography>
                    </Col>
                    <Col xs={24} md={12}>
                        <Typography
                            className="label"
                            size={12}
                            as="div"
                            color="rgba(255, 255, 255, 0.50)"
                        >
                            Кем выдан
                        </Typography>
                        <Typography className="value" size={14} as="div" color="#fff">
                            {_.get(reservations, "phone.abonentPassport.passport_vidan")
                                ? _.get(reservations, "phone.abonentPassport.passport_vidan")
                                : "-"}
                        </Typography>
                    </Col>

                    <Col xs={12} md={6}>
                        <Typography
                            className="label"
                            size={12}
                            as="div"
                            color="rgba(255, 255, 255, 0.50)"
                        >
                            Серия паспорта
                        </Typography>
                        <Typography className="value" size={14} as="div" color="#fff">
                            {_.get(reservations, "phone.abonentPassport.document_series") ? (
                                <>
                                    {`${(
                                        _.get(
                                            reservations,
                                            "phone.abonentPassport.document_series"
                                        ) as any
                                    ).substring(0, 2)} 
                            ${(
                                _.get(reservations, "phone.abonentPassport.document_series") as any
                            ).substring(2, 4)}`}
                                </>
                            ) : (
                                "-"
                            )}
                        </Typography>
                    </Col>
                    <Col xs={12} md={6}>
                        <Typography
                            className="label"
                            size={12}
                            as="div"
                            color="rgba(255, 255, 255, 0.50)"
                        >
                            Номер паспорта
                        </Typography>
                        <Typography className="value" size={14} as="div" color="#fff">
                            {_.get(reservations, "phone.abonentPassport.passport_nomer") ? (
                                <>
                                    {`${(
                                        _.get(
                                            reservations,
                                            "phone.abonentPassport.passport_nomer"
                                        ) as any
                                    ).substring(0, 3)} 
                            ${(
                                _.get(reservations, "phone.abonentPassport.passport_nomer") as any
                            ).substring(3, 6)}`}
                                </>
                            ) : (
                                "-"
                            )}
                        </Typography>
                    </Col>

                    <Col xs={12} md={12}>
                        <Typography
                            className="label"
                            size={12}
                            as="div"
                            color="rgba(255, 255, 255, 0.50)"
                        >
                            Дата выдачи
                        </Typography>
                        <Typography className="value" size={14} as="div" color="#fff">
                            {_.get(reservations, "phone.abonentPassport.passport_kogda_vidan")
                                ? moment(
                                      _.get(
                                          reservations,
                                          "phone.abonentPassport.passport_kogda_vidan"
                                      )
                                  ).format("DD.MM.YYYY")
                                : "-"}
                        </Typography>
                    </Col>
                    <Col xs={12} md={12}>
                        <Typography
                            className="label"
                            size={12}
                            as="div"
                            color="rgba(255, 255, 255, 0.50)"
                        >
                            Код подразделения
                        </Typography>
                        <Typography className="value" size={14} as="div" color="#fff">
                            {_.get(reservations, "phone.abonentPassport.division_code") ? (
                                <>{_.get(reservations, "phone.abonentPassport.division_code")}</>
                            ) : (
                                "-"
                            )}
                        </Typography>
                    </Col>

                    <Col xs={24} md={24}>
                        <Typography
                            className="label"
                            size={12}
                            as="div"
                            color="rgba(255, 255, 255, 0.50)"
                        >
                            Населенный пункт
                        </Typography>
                        <Typography className="value" size={14} as="div" color="#fff">
                            {_.get(reservations, "phone.abonentPassport.place_name") ? (
                                <>{_.get(reservations, "phone.abonentPassport.place_name")}</>
                            ) : (
                                "-"
                            )}
                        </Typography>
                    </Col>

                    <Col xs={24} md={12}>
                        <Typography
                            className="label"
                            size={12}
                            as="div"
                            color="rgba(255, 255, 255, 0.50)"
                        >
                            Улица
                        </Typography>
                        <Typography className="value" size={14} as="div" color="#fff">
                            {_.get(reservations, "phone.abonentPassport.street_name") ? (
                                <>{_.get(reservations, "phone.abonentPassport.street_name")}</>
                            ) : (
                                "-"
                            )}
                        </Typography>
                    </Col>
                    <Col xs={8} md={4}>
                        <Typography
                            className="label"
                            size={12}
                            as="div"
                            color="rgba(255, 255, 255, 0.50)"
                        >
                            Дом
                        </Typography>
                        <Typography className="value" size={14} as="div" color="#fff">
                            {_.get(reservations, "phone.abonentPassport.house")
                                ? _.get(reservations, "phone.abonentPassport.house")
                                : "-"}
                        </Typography>
                    </Col>
                    <Col xs={8} md={4}>
                        <Typography
                            className="label"
                            size={12}
                            as="div"
                            color="rgba(255, 255, 255, 0.50)"
                        >
                            Строение
                        </Typography>
                        <Typography className="value" size={14} as="div" color="#fff">
                            {_.get(reservations, "phone.abonentPassport.building_name")
                                ? _.get(reservations, "phone.abonentPassport.building_name")
                                : "-"}
                        </Typography>
                    </Col>
                    <Col xs={8} md={4}>
                        <Typography
                            className="label"
                            size={12}
                            as="div"
                            color="rgba(255, 255, 255, 0.50)"
                        >
                            Квартира
                        </Typography>
                        <Typography className="value" size={14} as="div" color="#fff">
                            {_.get(reservations, "phone.abonentPassport.apartment_name")
                                ? _.get(reservations, "phone.abonentPassport.apartment_name")
                                : "-"}
                        </Typography>
                    </Col>
                </Row>
                <Row gutter={[24, 24]} className="mt-25 bottom">
                    <Col xs={24}>
                        <Typography className="photo-title" size={24} as="div" color="#fff">
                            Фото паспорта
                        </Typography>
                    </Col>
                    <Col xs={12} className="text-right">
                        {_.get(reservations, "phone.abonentPassport.photos.front.url") && (
                            <img
                                className="photo"
                                src={_.get(reservations, "phone.abonentPassport.photos.front.url")}
                                alt=""
                            />
                        )}
                    </Col>
                    <Col xs={12}>
                        {_.get(reservations, "phone.abonentPassport.photos.back.url") && (
                            <img
                                className="photo"
                                src={_.get(reservations, "phone.abonentPassport.photos.back.url")}
                                alt=""
                            />
                        )}
                    </Col>
                    <Col xs={24} className="actions">
                        <Button type="primary" onClick={onClick}>
                            Изменить паспортные данные
                        </Button>
                    </Col>
                </Row>
            </Typography>
        </Typography>
    );
});

interface IProps {
    reservations: IReservations;
}
